// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareListModalStyles } from "@guestsupply/Overrides/Components/ShareListModal";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

const tooltipIconStyle: TooltipPresentationProps = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
            display: flex;
            align-items: center;
            margin-top: 2px;
        `,
    },
    typographyProps: {
        weight: "normal",
    },
    iconProps: {
        css: css`
            height: 9px;
        `,
    },
};

shareListModalStyles.recipientEmailTooltip = {
    ...tooltipIconStyle,
};

shareListModalStyles.shareByEmailTooltip = {
    ...tooltipIconStyle,
};

shareListModalStyles.shareByBillingTooltip = {
    ...tooltipIconStyle,
};

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
            display: flex;
            align-items: center;
        `,
        tooltipContainer: css`
            width: 500px;
            ${xScreen("lte", "xs")} {
                width: 290px;
            }
        `,
        tooltipBody: css`
            padding: 5px;
        `,
    },
    typographyProps: {
        lineHeight: "16px",
    },
    iconProps: {
        css: css`
            height: 9px;
        `,
    },
};

shareListModalStyles.shareMessageTextArea = {
    cssOverrides: {
        inputSelect: css`
            resize: none;
        `,
    },
};

shareListModalStyles.inviteMessageTextArea = {
    cssOverrides: {
        inputSelect: css`
            resize: none;
        `,
    },
};

shareListModalStyles.buttonsContainer = {
    gap: 10,
    offsetCss: css`
        justify-content: flex-end;
    `,
};

shareListModalStyles.shareByOptionRadioGroup = {
    css: css`
        flex-direction: row;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;
                    `,
                ],
                "max",
            )}
    `,
};

shareListModalStyles.shareByEmailRadio = {
    css: css`
        & + & {
            margin-top: 0 !important;
            margin-left: 20px;
            ${xScreen("lte", "xs")} {
                margin-left: 0;
            }
        }
        input {
            margin-left: 0;
        }
    `,
};

shareListModalStyles.shareListOptionRadioGroup = shareListModalStyles.shareByOptionRadioGroup;

shareListModalStyles.sendCopyRadio = shareListModalStyles.shareByEmailRadio;

shareListModalStyles.container = { gap: 15 };

shareListModalStyles.yourNameTextField = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            label {
                line-height: 16px;
            }
        `,
    },
};
